<template>
	<c-dialog ref="dialog" width="100vw-300" mode="slide" mask-close @close="dialogFormEditConfirm($refs.stockinForm, arguments)" @resolve="editHandle">
		<c-form ref="stockinForm" column="3" vertical unit-width="100%">
			<c-title>基本信息</c-title>
			<c-form link-parent>
				<c-form-column>
					<c-form-item label="入库单号">
						<c-input name="order_code" placeholder="请输入，忽略将自动生成"></c-input>
					</c-form-item>
					<c-form-item label="入库时间" required>
						<c-datetime name="storage_date" type="datetime" format="yyyy-MM-dd hh:mm" time-accuracy="min" placeholder="请选择实际入库时间" v-model="storage_date"></c-datetime>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="仓库" required>
						<c-select ref="warehouse" name="warehouse_id" v-model="warehouse_id" async @search="searchWarehouse"  :value-data="warehouseOptions" :clear="false"></c-select>
						<template #handle>
							<c-tooltip tip="仓库切换将清空入库明细商品，请谨慎操作" position="top"></c-tooltip>
						</template>
					</c-form-item>
					<c-form-item label="入库类型" required>
                        <c-input name="order_classify" disabled></c-input>
					</c-form-item>
				</c-form-column>

				<c-form-column>
					<c-form-item label="备注">
						<c-input type="textarea" name="remark"></c-input>
					</c-form-item>
					<c-form-item label="供应商">
						<c-select name="supplier_id" async @search="searchSupplier" :value-data="supplierOptions" disabled :clear="false"></c-select>
					</c-form-item>
				</c-form-column>

				<!--自定义字段-->
				<custom-form ref="customForm" work-type="20"></custom-form>
			</c-form>
			<c-title >入库明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
				<custom-table ref="productTable" :view-id="view_id" work-type="21">
					<template #empty>
						<c-empty :message="warehouse_id ? '暂无可收货产品' : '请先选择仓库'"></c-empty>
					</template>
					<template #otherOperate>
						<c-button color="red" hollow prepend-icon="tf-clear" @click="clearNonData()">清除无效数据</c-button>
					</template>
					
					<!--产品来源-->
					<template #product_source="{data}">
						<c-state dict="productSourceName" :value="data.product_source"></c-state>
					</template>
					
					<!--商品类型-->
					<template #product_type="{data}">
						<c-state dict="productTypeName" :value="data.product_type"></c-state>
					</template>
					<!--入库数量-->
					<template #view_product_count="{data}">
						<c-input type="stepper" decimal="6" :range="[0,99999999]" v-model="data.view_product_count"></c-input>
					</template>

					<c-table-column
                        type="button"
                        label="操作"
						width="60"
                    >
                        <template #default="{data,remove}">
							<c-table-button icon="tf-trash" @click="removeRow(data,remove)">删除</c-table-button>
						</template>
					</c-table-column>
				</custom-table>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
	name: 'purchase_storage_edit',
	computed: {
		// 获取dictName选项数据
		...mapState(['stockinClassifyName','productTypeName']),
	},
	watch: {
	    // 仓库发生变化，重新加载库存
	    warehouse_id(newVal, oldVal) {
			if(newVal != 0){
				//按库存重新加载
				this.getPurchaseDetail();
			}
		}
	},
	data() {
		return {
			view_id:10005,
            purchase_order_id:0,
			storage_date:'',
			productList:[],
			deleteProductList:[],
			warehouseOptions:[],
			ref_type:39, //关联单据类型（0：自建，14：报工，3：工单，32：发货，39：采购）
			order_classify:11,//11=【采购入库】
			warehouse_id:0,
			supplierOptions: []//已选中的供应商信息
		}
	},
	methods: {
		/************打开新增、编辑弹窗**************/
		open(purchase_order_id) {
			this.warehouse_id = 0;//仓库ID，初始化为0，确保每次打开弹窗时都重新加载仓库数据
			//自定义字段控件初始化
			this.$refs.customForm.init();
			//初始化产品列表控件
			this.$refs.productTable.init();
			this.deleteProductList = [];
			this.$refs.stockinForm.clear();
            //选中默认仓库
            this.getDefaultWarehouse();
            this.purchase_order_id = purchase_order_id;
            //this.getPurchaseDetail();
			this.$refs.dialog.open({
				title: '采购单收货入库'
			});
		},

		/*******搜索【客户】下拉框信息*****************/
		searchCustomer(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'CUSTOMER',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索【供应商】下拉框信息*****************/
		searchSupplier(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SUPPLIER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******查询[采购单]详情*******************/
        getPurchaseDetail() {
			this.request({
				url:'/purchase/order/detail',
				data: {
					id: this.purchase_order_id,
					warehouse_id: this.warehouse_id
				},
				loading: true,
				success: async data => {
                    this.$refs.stockinForm.set({
                        storage_date: new Date().format('yyyy-MM-dd hh:mm'),
                        order_classify: this.stockinClassifyName.find(item=>item.value == this.order_classify).name,
                        supplier_id: data.detailInfo.supplier_id,
                        remark: '采购单【'+data.detailInfo.purchase_code+'】收货入库'
                    });
					if (data && data.detailInfo && data.detailInfo.supplier_id && data.detailInfo.supplier_name){
						this.supplierOptions = [{
							name:data.detailInfo.supplier_code +' - ' +data.detailInfo.supplier_name,
							value:data.detailInfo.supplier_id
						}];
					}else {
						this.supplierOptions = [];
					}
					//加载产品列表
                    var productList = data.productList.map(item => {
                        var obj = Object.assign({}, item);
                        obj.is_db = 0;
                        obj.old_product_count = 0;
						obj.ref_detail_id = item.id;
                        var count = item.purchase_count - item.storage_count;//入库数量等于采购数量 - 已入库数
                        obj.view_product_count = count<=0?0:count;
                        return obj;
                    });
                    //按来源填充明细自定义字段默认值（采购单明细 + 产品）
                    this.$refs.productTable.$refs.list.setData(
                        await this.$refs.productTable.setDefaultData(productList, {
                            work_type_id: 21,
                            source_list: productList.map(item => {
                                return [{
                                    ref_work_type_id: 40,
                                    ref_id: item.id
                                }, {
                                    ref_work_type_id: 7,
                                    ref_id: item.product_id
                                }];
                            })
                        })
                    );
				}
			});
		},

		/***
		 **查询默认仓库
		 **/
		getDefaultWarehouse(){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE'
				},
				success:data => {
					if (data.length == 1){
						this.warehouseOptions = [data[0]];
						this.warehouse_id = data[0].value;
					}
				}
			});
		},

		/*******搜索【仓库】下拉框信息*****************/
		searchWarehouse(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'WAREHOUSE',
					keyword:keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/******删除行数据********/
		removeRow(data, remove) {
			if (data.is_db == 1 && data.id && data.id > 0){
				this.deleteProductList.push(data.id);
			}
			remove();
		},
		
		/**清除无效数据**/
		clearNonData(){
			const dataList = this.$refs.productTable.$refs.list.getRow();
			for (let i = dataList.length - 1; i >= 0; i--) {
			    const row = dataList[i];
			    const count = row.data?.view_product_count;
			    // 数量为空、undefined、null、0 都判定为无效
			    if (!count || Number(count) === 0) {
					row.remove();
			    }
			}
		},

		/*******提交编辑数据********************/
		editHandle(stop, next) {
			stop();
			//入库商品
			var product_list = this.$refs.productTable.$refs.list.getData();
			this.$refs.stockinForm.submit({
				url: '/stockin/order/add',
				rule: {
					warehouse_id: '请选择入库仓库',
					storage_date: '请选择入库时间',
					product_list: data => {
						var flag = true;
						if(product_list.length == 0) return "请添加产品明细";
						product_list.forEach(item => {
							if(!item.view_product_count || isNaN(item.view_product_count) || item.view_product_count ==0){
								flag = false;
							}
						});
						if (!flag) {
							return '请完善产品明细';
						}
						//自定义字段校验
						return this.$refs.productTable.validate();
					},
					...this.$refs.customForm.rule
				},
			    dataFormatter: data => {
					data.id = 0;
					data.order_classify = this.order_classify;
					data.ref_type = this.ref_type;
					data.ref_id = this.purchase_order_id;
				    data.product_list  = product_list.map(item => {
					    return {
						    id:item.id,
							ref_detail_id:item.ref_detail_id,
						    product_id:item.product_id,
						    old_product_count:item.old_product_count,
						    view_product_count:item.view_product_count,
							product_price: parseFloat(item.product_price||0),
						    custom_fields_value_json: JSON.stringify(item.custom_fields_value_json)
					    }
				    });
					data.delete_product_list = this.deleteProductList;
				    data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
				    return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message:'采购单收货成功',
					});
					//刷新页面
					this.$emit('resolve');
				}
			})
		}
	}
}
</script>
<style lang="stylus" scoped>
</style>